import { useEffect } from "react";

export const useFreshworksWidget = () => {
  useEffect(() => {
    if (!document.getElementById("vpd-freshworks-script")) {
      const script = document.createElement("script");
      script.setAttribute("id", "vpd-freshworks-script");
      // @ts-ignore
      window.fwSettings = {
        widget_id: 103000005508,
      };

      // @ts-ignore
      !(function () {
        // @ts-ignore
        if ("function" != typeof window.FreshworksWidget) {
          const n = function () {
            // eslint-disable-next-line prefer-rest-params
            n.q.push(arguments);
          };
          // @ts-ignore
          (n.q = []), (window.FreshworksWidget = n);
        }
      })();

      script.src = "https://euc-widget.freshworks.com/widgets/103000005508.js";
      script.async = true;

      document.body.appendChild(script);
    }
    // @ts-ignore
    FreshworksWidget("show", "launcher");
    return () => {
      // @ts-ignore
      FreshworksWidget("hide", "launcher");
    };
  }, []);
};
